import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

const PROFILES_BACKEND_URL = environment.apiUrl + '/profiles/';

@Injectable({
  providedIn: 'root',
})
export class WalletService {

  walletUrl = environment.walletBladiUrl + '/v0/wallet';
  
  // Add BehaviorSubject to store and share wallet information
  private _walletInfo = new BehaviorSubject<any>(null);
  walletInfo$ = this._walletInfo.asObservable();

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  /**
   * Fetch profiel driver data
   *
   */
  getDriverProfile(id: string): Observable<any | null> {
    return this._httpClient
      .get<any | null>(PROFILES_BACKEND_URL + 'review/fetch/' + id)
      .pipe(
        tap((response) => {
          console.log('FETCH DRIVER PROFILE RESPONSE => ', response);
          return response;
        }),
        catchError((error) => {
          console.error('FETCH DRIVER PROFILE ERROR => ', error);
          return of(null);
        })
      );
  }

  getWalletData(): Observable<any> {
    return this._httpClient
    .get<any>(this.walletUrl + '/data')
    .pipe(
      tap((response) => {
        console.log('FETCH DRIVER PROFILE RESPONSE => ', response);
        // Update the walletInfo BehaviorSubject when new data arrives
        this._walletInfo.next(response);
        return response;
      }),
      catchError((error) => {
        console.error('FETCH DRIVER PROFILE ERROR => ', error);
        return of(null);
      }))
  }
}
